import { __decorate, __metadata, __param } from "tslib";
import { element as ngElement } from 'angular';
import { Directive, Inject, Input } from 'angular-ts-decorators';
var ProductToolbarStickyDirective = (function () {
    function ProductToolbarStickyDirective($scope, $element, $window) {
        this.$scope = $scope;
        this.$element = $element;
        this.$window = $window;
    }
    ProductToolbarStickyDirective.prototype.ngOnInit = function () {
        var _this = this;
        var $win = ngElement(this.$window);
        var stickyCls = this.productToolbarSticky;
        var element = this.$element[0];
        var $container = ngElement(this.productToolbarContainer);
        var scroll = function () {
            if (element.offsetWidth === 0 && element.offsetHeight === 0) {
                _this.$element
                    .removeClass(stickyCls)
                    .next('.sticky-phantom')
                    .remove();
                return;
            }
            var isSticky = _this.$element.hasClass(stickyCls);
            var initialOffsetTop = isSticky ? _this.$element.next('.sticky-phantom').offset().top : _this.$element.offset().top;
            if ($win.scrollTop() >= initialOffsetTop) {
                if ($win.scrollTop() > $container.offset().top + $container.height() - _this.$element.height()) {
                    _this.$element.css('opacity', 0);
                }
                else {
                    _this.$element.css('opacity', 1);
                }
                if (_this.$element.hasClass(stickyCls)) {
                    return;
                }
                if (element.offsetHeight !== 0) {
                    _this.$element.after("<div class=\"sticky-phantom\" style=\"height: " + _this.$element.outerHeight() + "px;\"></div>");
                }
                _this.$element.addClass(stickyCls);
            }
            else if (_this.$element.hasClass(stickyCls)) {
                _this.$element
                    .removeClass(stickyCls)
                    .next('.sticky-phantom')
                    .remove();
            }
        };
        scroll();
        $win.on('scroll resize', scroll);
        this.$scope.$on('$destroy', function () {
            $win.off('scroll resize', scroll);
        });
    };
    ProductToolbarStickyDirective.$inject = ['$scope', '$element', '$window'];
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], ProductToolbarStickyDirective.prototype, "productToolbarSticky", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], ProductToolbarStickyDirective.prototype, "productToolbarContainer", void 0);
    ProductToolbarStickyDirective = __decorate([
        Directive({
            selector: '[productToolbarSticky]',
        }),
        __param(0, Inject('$scope')),
        __param(1, Inject('$element')),
        __param(2, Inject('$window')),
        __metadata("design:paramtypes", [Object, Object, Object])
    ], ProductToolbarStickyDirective);
    return ProductToolbarStickyDirective;
}());
export { ProductToolbarStickyDirective };
